// extracted by mini-css-extract-plugin
export default {"improvements-button":"bPq9qWw1Kt86VsgV_Gjw","tooltip-link":"Fgs_emI35qTeeYC5AlAj"};